import { Vertical } from '@/types/verticals'

interface MembershipInfo {
  description: string
  icon: string
}

export const valueProps: Record<Vertical, Record<string, MembershipInfo[]>> = {
  [Vertical.Hunt]: {
    ELITE: [
      {
        description: 'Elite-Exclusive Map Tools',
        icon: 'basemap-2d',
      },
      {
        description: 'Pro Deals on Top Hunting Brands',
        icon: 'offroad/deals',
      },
      {
        description: 'Application Season Research Tools',
        icon: 'research',
      },
      {
        description: 'Expert Hunting Education Resources',
        icon: 'book-closed',
      },
    ],
    PREMIUM: [
      {
        description: 'Public & Private Land Maps for 1 State',
        icon: 'flag',
      },
      {
        description: 'Unlimited Offline Maps',
        icon: 'offroad/offline',
      },
      {
        description: '3D, Aerial, and Topo Basemaps',
        icon: 'layers-stacked',
      },
      {
        description: 'Customizable, Shareable Waypoints',
        icon: 'coordinate',
      },
    ],
    PREMIUM_MULTI_STATE: [
      {
        description: 'Public & Private Land Maps for 2 States',
        icon: 'flag',
      },
      {
        description: 'Unlimited Offline Maps',
        icon: 'offroad/offline',
      },
      {
        description: '3D, Aerial, and Topo Basemaps',
        icon: 'layers-stacked',
      },
      {
        description: 'Customizable, Shareable Waypoints',
        icon: 'coordinate',
      },
    ],
  },
  [Vertical.Offroad]: {
    ELITE: [
      {
        description: 'Elite-Exclusive Pro Deals',
        icon: 'offroad/deals',
      },
      {
        description: 'Private Land Ownership in the US & Canada',
        icon: 'offroad/barrier',
      },
      {
        description: 'Offroad Trails & Public Lands in the US, Mexico & Canada',
        icon: 'offroad/rides',
      },
      {
        description: 'Unlimited Offline Maps',
        icon: 'offroad/offline',
      },
    ],
    PREMIUM: [
      {
        description: 'Offroad Trails & Public Lands in the US',
        icon: 'offroad/rides',
      },
      {
        description: 'Unlimited Offline Maps',
        icon: 'offroad/offline',
      },
    ],
  },
  [Vertical.Backcountry]: {
    ELITE: [
      {
        description: 'Private Land Ownership',
        icon: 'offroad/barrier',
      },
      {
        description: 'Recent Imagery',
        icon: 'recent-imagery',
      },
      {
        description: 'Terrain X',
        icon: 'terrain-x',
      },
    ],
    PREMIUM: [
      {
        description: 'Over 10k Guidebook Routes',
        icon: 'snowflake',
      },
      {
        description: 'Over 650k Miles of Trails',
        icon: 'build-route',
      },
      {
        description: 'Unlimited Offline Maps',
        icon: 'offroad/offline',
      },
      {
        description: 'Avalanche Forecasts',
        icon: 'backcountry/avy',
      },
      {
        description: 'Route Building Tools',
        icon: 'stat-track',
      },
      {
        description: 'Smoke Forecast & Air Quality',
        icon: 'weather/hourly/smoke',
      },
      {
        description: 'Premium Map Layers (Slope Angle, Slope Aspect, ...)',
        icon: 'layers-stacked',
      },
    ],
  },
  [Vertical.Fish]: {},
}
